import { Navigate, Outlet } from "react-router-dom";
import { INSPECTION_HOME, isInspectionOnlyUser } from "../../inspection/index.jsx";

function OfficeRoute({ currentUser }) {
  if (isInspectionOnlyUser(currentUser)) {
    return <Navigate to={INSPECTION_HOME} replace />;
  }
  return <Outlet />;
}

export default OfficeRoute;
